import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { useThemeContext } from '../../styles/themes/themes.js';
import { DatePicker } from '../DatePicker/DatePicker.js';
import { DateInputBase } from './DateInputBase.js';
import { DateSpinButton } from './DateSpinButton.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["locale", "onChange", "time", "value"];

function getDateForma(_ref) {
  var _locale$formatLong, _locale$formatLong2, _locale$formatLong3;

  var locale = _ref.locale,
      time = _ref.time;
  var f;
  var dateFormat = locale === null || locale === void 0 ? void 0 : (_locale$formatLong = locale.formatLong) === null || _locale$formatLong === void 0 ? void 0 : _locale$formatLong.date({
    width: "medium"
  });
  var timeFormat = locale === null || locale === void 0 ? void 0 : (_locale$formatLong2 = locale.formatLong) === null || _locale$formatLong2 === void 0 ? void 0 : _locale$formatLong2.time({
    width: "medium"
  });
  var dateTimeFormat = locale === null || locale === void 0 ? void 0 : (_locale$formatLong3 = locale.formatLong) === null || _locale$formatLong3 === void 0 ? void 0 : _locale$formatLong3.dateTime({
    width: "medium"
  });

  if (time) {
    f = dateTimeFormat.replace("{{date}}", dateFormat);
    f = f.replace("{{time}}", timeFormat);

    if (time.clock === "24hour" && timeFormat.match(/h+/)) {
      f = f.replace(/h/g, "H");
      f = f.replace(/a+/, "").trim();
    }
  } else {
    f = dateFormat;
  }

  return f;
}

var DateInput = /*#__PURE__*/React.forwardRef(function DateInput2(props, ref) {
  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  var _props$locale = props.locale,
      locale = _props$locale === void 0 ? i18n.DatePicker.locale : _props$locale,
      onChange = props.onChange,
      time = props.time,
      value = props.value,
      dateFieldBaseProps = _objectWithoutProperties(props, _excluded);

  var dateFormat = getDateForma({
    time: time,
    locale: locale
  });
  return /*#__PURE__*/jsx(DateInputBase, _objectSpread(_objectSpread({}, dateFieldBaseProps), {}, {
    closeButtonProps: {
      onClick: function onClick(e) {
        e.stopPropagation();
        onChange();
      }
    },
    locale: locale,
    ref: ref,
    renderDatePicker: function renderDatePicker(datePickerProps) {
      return /*#__PURE__*/jsx(DatePicker, _objectSpread(_objectSpread({}, datePickerProps), {}, {
        variant: {
          onChange: onChange,
          time: time,
          type: "date",
          value: value
        }
      }));
    },
    renderSpinButton: function renderSpinButton(spinButtonProps) {
      return /*#__PURE__*/jsx(DateSpinButton, _objectSpread(_objectSpread({}, spinButtonProps), {}, {
        "aria-label": i18n.DateInput.spinButtonLabel,
        dateFormat: dateFormat,
        locale: locale,
        onChange: onChange,
        value: value
      }));
    }
  }));
});
DateInput.propTypes = {
  "locale": _PropTypes.shape({
    "code": _PropTypes.string,
    "formatDistance": _PropTypes.func,
    "formatLong": _PropTypes.shape({
      "date": _PropTypes.func.isRequired,
      "dateTime": _PropTypes.func.isRequired,
      "time": _PropTypes.func.isRequired
    }),
    "formatRelative": _PropTypes.func,
    "localize": _PropTypes.shape({
      "day": _PropTypes.func.isRequired,
      "dayPeriod": _PropTypes.func.isRequired,
      "era": _PropTypes.func.isRequired,
      "month": _PropTypes.func.isRequired,
      "ordinalNumber": _PropTypes.func.isRequired,
      "quarter": _PropTypes.func.isRequired
    }),
    "match": _PropTypes.shape({
      "day": _PropTypes.func.isRequired,
      "dayPeriod": _PropTypes.func.isRequired,
      "era": _PropTypes.func.isRequired,
      "month": _PropTypes.func.isRequired,
      "ordinalNumber": _PropTypes.func.isRequired,
      "quarter": _PropTypes.func.isRequired
    }),
    "options": _PropTypes.shape({
      "firstWeekContainsDate": _PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
      "weekStartsOn": _PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6])
    })
  }),
  "onChange": _PropTypes.func.isRequired,
  "time": _PropTypes.shape({
    "clock": _PropTypes.oneOf(["12hour", "24hour"]),
    "timezone": _PropTypes.shape({
      "error": _PropTypes.bool,
      "onChange": _PropTypes.func,
      "options": _PropTypes.arrayOf(_PropTypes.object).isRequired,
      "value": _PropTypes.oneOfType([_PropTypes.arrayOf(_PropTypes.string), _PropTypes.string])
    })
  }),
  "value": _PropTypes.instanceOf(Date)
};
DateInput.displayName = "DateInput";

export { DateInput };
